module.exports = __webpack_public_path__ + "img/562.5daa4f0a.jpg";